/*
 * Pawsitive Signs — Style → Custom-description prompt map
 *
 * When a customer clicks "Use this style" in the gallery, the wizard opens with
 * the matching entry below auto-filled into the "Custom description" field.
 *
 * Edit the strings to taste. Keys must match a wizard style id used by the gallery
 * blocks (see Style gallery section settings → Wizard style).
 *
 * Tips:
 *   • Keep descriptions concrete and visual — the AI uses them verbatim.
 *   • Mention background, palette, type style and any motifs you want preserved.
 *   • Add new keys as you add new gallery styles; unmapped ids fall through to the
 *     wizard's preset of the same id.
 */
window.PW_STYLE_PROMPTS = {
  celtic:
    "Intricate Celtic knotwork border in deep emerald green and aged gold, misty forest backdrop with soft moonlight, cream serif lettering with gold filigree accents — regal, enchanting, woodland mood.",

  watercolor:
    "Soft hand-painted watercolour wash, muted blues and dusty lavender bleeding into cream paper, gentle organic edges, flowing handwritten script in deep indigo — dreamy and painterly.",

  vintage:
    "Vintage enamel sign aesthetic with distressed cream background and deep oxblood red border, classic condensed serif type, subtle edge wear and patina, retro café-style charm.",

  cartoon:
    "Bright sunny cartoon garden scene, bold playful sans-serif text with thick black outlines, cheerful yellows and lush leafy greens, illustrated flowers and butterflies — joyful and animated.",

  "art-deco":
    "Art Deco geometric patterns in midnight navy and brushed gold, symmetrical fan and chevron motifs framing the text, tall elegant capital lettering — sophisticated and luxurious.",

  coastal:
    "Crisp coastal palette of deep navy and bright white, subtle rope-knot border, clean modern sans-serif text, hint of sun-bleached driftwood texture — fresh, breezy, nautical.",

  rustic:
    "Warm rustic wood-plank background with visible grain, hand-carved engraved feel, charcoal lettering with soft cast shadows, small leaf or paw motifs — handmade farmhouse charm.",

  minimalist:
    "Pure minimalist design on warm off-white, single thin charcoal border, modern geometric sans-serif text centred and balanced, generous negative space — quiet and contemporary.",

  botanical:
    "Lush botanical illustration with trailing leaves, ferns and small wildflowers framing the text, deep forest green background, elegant cream serif lettering — verdant English-garden feel.",
};
